/*
subclip copied from https://github.com/mrdoob/three.js/blob/master/src/animation/AnimationUtils.js#L143
and then cleaned up to use TypeScript as well as ensure that we're using our local version of KeyframeTrack
*/
import { AnimationClip } from 'three';

import { KeyframeTrack } from './KeyframeTrack';

export default function subclip(
  sourceClip: AnimationClip,
  name: string,
  startFrame: number,
  endFrame: number,
  fps: number = 30,
): AnimationClip {
  // WARN: sourceClip.clone() does NOT actually clone
  // it tries to reduce redundant keys, which is not what we want
  const clip = sourceClip.clone();

  clip.name = name;

  const tracks: KeyframeTrack[] = [];

  for (let i = 0; i < sourceClip.tracks.length; ++i) {
    const track = sourceClip.tracks[i];
    const valueSize = track.getValueSize();

    const times: number[] = [];
    const values: number[] = [];

    for (let j = 0; j < track.times.length; ++j) {
      const frame = Math.round(track.times[j] * fps);

      if (frame < startFrame || frame >= endFrame) continue;

      times.push(track.times[j]);

      for (let k = 0; k < valueSize; ++k) {
        values.push(track.values[j * valueSize + k]);
      }
    }

    if (times.length === 0) continue;

    const newTrack = new KeyframeTrack(track.name, times, values);
    tracks.push(newTrack);
  }

  // the casting of "as any" is intentional because we use a custom KeyframeTrack class instead of the default Three.js
  clip.tracks = tracks as any;

  // find minimum .times value across all tracks in the trimmed clip

  let minStartTime = Infinity;

  for (let i = 0; i < clip.tracks.length; ++i) {
    if (minStartTime > clip.tracks[i].times[0]) {
      minStartTime = clip.tracks[i].times[0];
    }
  }

  // shift all tracks such that clip begins at t=0
  // and calculate new max duration.
  // Similar to BVHLoader, we need to extend the duration
  // so that the last frame gets "held" by the mixer
  let maxDuration = 0;
  const frameTime = 1 / fps;
  for (let i = 0; i < clip.tracks.length; ++i) {
    clip.tracks[i].shift(-1 * minStartTime);
    const newDuration = clip.tracks[i].times.at(-1)! + frameTime;
    maxDuration = Math.max(maxDuration, newDuration);
  }

  clip.duration = maxDuration;

  return clip;
}
